var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ucrs-doughnut"},[_c('AsyncDoughnutChart',{attrs:{"chart-data":_vm.computedData,"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }